import { useState } from "react";
import { Pencil } from "lucide-react";
import UserProfilePic from "./UserProfilePic";
import { CustomButton } from "@/components/ui/Buttons";
import Modal from "@/components/ui/Modal";
import EditPersonalDetailsModal from "./modals/EditPersonalDetailsModal";
import { TUser } from "@/types/types";
import ToggleButton from "./ToggleButton";

type PersonalDetailsProps = {
  data: TUser;
};

// Main Component
const PersonalDetails = ({ data }: PersonalDetailsProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <div className="bg-white p-6 border border-[#E4E7EC] rounded-xl shadow space-y-5">
        <div>
          <ToggleButton />
          <div className="flex justify-between">
            <h6 className="text-[#344054] text-sm leading-5 font-medium mb-3">
              Profile pic
            </h6>
            <CustomButton
              onClick={() => setIsOpen(true)}
              variant="outline"
              color="#344054"
              fontSize="14px"
              padding="8px 12px"
              border="1px solid #E8EBEE"
              borderRadius="8px"
              className="flex items-center gap-1"
            >
              <Pencil className="size-4" />
              Edit
            </CustomButton>
          </div>
          <UserProfilePic />
        </div>

        <div className="grid grid-cols-2 place-content-between gap-y-5">
          <DetailField label="Full name" value={data?.fullName} />
          <DetailField label="Email" value={data?.email} />
          <DetailField label="Phone number" value={data?.phoneNumber} />
          <DetailField label="Age" value={data?.age} />
          <DetailField label="City" value={data?.address?.city} />
          <DetailField label="State" value={data?.address?.state} />
          <DetailField label="Country" value={data?.address?.country} />
          <DetailField label="Zip Code" value={data?.address?.zipCode} />
          <DetailField label="Skin Tone" value={data?.skinTone} />
          <DetailField label="Body Type" value={data?.bodyType} />
          <DetailField label="Gender" value={data?.gender} />
        </div>

        <div>
          <h5 className="text-sm font-medium text-gray-900 mb-1">Bio</h5>
          <p
            className={`text-sm  ${
              data?.bio ? "text-gray-600" : "text-red-500 font-medium"
            }`}
          >
            {data?.bio || "No bio provided"}
          </p>
        </div>
      </div>

      <Modal
        width="555px"
        isOpen={isOpen}
        setOpen={setIsOpen}
        padding="0px"
        preventCloseOnClickOutside={true}
      >
        <EditPersonalDetailsModal data={data} onClose={setIsOpen} />
      </Modal>
    </>
  );
};

export default PersonalDetails;

const DetailField = ({
  label,
  value,
}: {
  label: string;
  value: string | number | undefined;
}) => (
  <div>
    <h5 className="text-sm font-medium text-gray-900 mb-1">{label}</h5>
    <p
      className={`text-sm truncate w-[120px] lg:w-full ${
        value === null || value === undefined
          ? "text-red-500 font-medium"
          : "text-gray-600"
      }`}
    >
      {value || "Not provided"}
    </p>
  </div>
);
